<script>
import Vue from 'vue/dist/vue.common.js';
import VeeValidate from 'vee-validate';
import Icon from './icon';

Vue.use(VeeValidate);
import EventBus from '../instances/event-bus';
import store from '../vuex/store';
import UserSubmissionsService from '../services/user-submissions';

export default {
  components: {
    Icon
  },
  data() {
    return {
      person: {
        biography: '',
        gender: '',
        party: '',
        race: '',
        phone: '',
        email: '',
        website: '',
        agenda: '',
        city: '',
        state: '',
        zip: '',
        streetAddress1: '',
        streetAddress2: '',
        streetAddress3: '',
      },
      submitted: false,
      posting: false
    }
  },
  props: {
    resourceType: { required: true },
    resourceId: { required: true }
  },
  computed: {
    loggedIn() { return this.$store.state.loggedIn; },
    parties() { return this.$store.state.data.parties; },
    races() { return this.$store.state.data.races; },
    valid () {
      const self = this;
      if ( self.fields.email.valid && self.fields.zip.valid && self.fields.website.valid && self.fields.agenda.valid ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.$store.dispatch('data/getParties');
    this.$store.dispatch('data/getRaces');
  },
  methods: {
    cancel() {
      EventBus.$emit('closeModal');
    },
    submit() {
      this.createUserSubmission("biography", this.person.biography);
      this.createUserSubmission("gender", this.person.gender);
      this.createUserSubmission("party", this.person.party);
      this.createUserSubmission("race", this.person.race);
      this.createUserSubmission("phone", this.person.phone);
      this.createUserSubmission("email", this.person.email);
      this.createUserSubmission("website", this.person.website);
      this.createUserSubmission("agenda", this.person.agenda);
      this.createUserSubmission("city", this.person.city);
      this.createUserSubmission("state", this.person.state);
      this.createUserSubmission("zip", this.person.zip);
      this.createUserSubmission("street_address_1", this.person.streetAddress1);
      this.createUserSubmission("street_address_2", this.person.streetAddress2);
      this.createUserSubmission("street_address_3", this.person.streetAddress3);
      this.submitted = true;
    },
    createUserSubmission(field, value) {
      if (!!value) {
        UserSubmissionsService.create(this.resourceId, this.resourceType, field, value)
      }
    },
  }
}
</script>

<template lang="html">
  <div v-if="!!loggedIn">
    <form class="u-form u-form--light" @submit.prevent="submit">
      <div v-if="!submitted">
        <div class="u-mb2">
          <label for="person-user-form-bio">Biography</label>
          <textarea id="person-user-form-bio" placeholder="Provide a biography for this person" rows="5" v-model="person.biography"/>
        </div>

        <div class="u-mb2">
          <label for="person-user-form-gender">Gender</label>
          <div class="js-custom-select u-form-shortWrapper">
            <select id="person-user-form-gender" v-model="person.gender">
              <option value="">Select a gender</option>
              <option value="f">Female</option>
              <option value="m">Male</option>
            </select>
            <icon icon="arrow-down"></icon>
          </div>
        </div>

        <div class="u-mb2">
          <label for="person-user-form-party">Party Affiliation</label>
          <div class="js-custom-select u-form-shortWrapper">
            <select id="person-user-form-party" v-model="person.party">
              <option value="">Select a party</option>
              <option v-for="(party, index) in parties" :value="party.id">{{ party.name }}</option>
            </select>
            <icon icon="arrow-down"></icon>
          </div>
        </div>

        <div class="u-mb2">
          <label for="person-user-form-race">Race</label>
          <div class="js-custom-select u-form-shortWrapper">
            <select id="person-user-form-race" v-model="person.race">
              <option value="">Select a race</option>
              <option v-for="(race, index) in races" :value="race.key">{{ race.value }}</option>
            </select>
            <icon icon="arrow-down"></icon>
          </div>
        </div>

        <div class="u-mb2 u-form-shortWrapper">
          <label for="person-user-form-phone">Phone</label>
          <input type="text" id="person-user-form-phone" placeholder="Provide a phone number for this person" v-model="person.phone"/>
        </div>

        <div class="u-mb2 u-form-shortWrapper">
          <label for="person-user-form-email">
            Email
            <span data-error v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </label>
          <input type="email" name="email" id="person-user-form-email" placeholder="Provide an email address for this person" v-model="person.email" v-validate="{ required: false, email: true }"/>
        </div>

        <div class="u-mb2 u-form-shortWrapper">
          <label for="person-user-form-website">
            Website
            <span data-error v-show="errors.has('website')">{{ errors.first('website') }}</span>
          </label>
          <input type="text" name="website" id="person-user-form-website" placeholder="Provide a website URL for this person" v-model="person.website" v-validate="{ required: false, url: true }"/>
        </div>

        <div class="u-mb2 u-form-shortWrapper">
          <label for="person-user-form-agenda">
            Agenda
            <span data-error v-show="errors.has('agenda')">{{ errors.first('agenda') }}</span>
          </label>
          <input type="text" name="agenda" id="person-user-form-agenda" placeholder="Provide a website URL for this person's agenda" v-model="person.agenda" v-validate="{ required: false, url: true }"/>
        </div>

        <div class="u-mb2 u-form-shortWrapper">
          <label for="person-user-form-city">City</label>
          <input type="text" id="person-user-form-city" placeholder="Provide a city for this person" v-model="person.city"/>
        </div>

        <div class="u-mb2 u-form-shortWrapper">
          <label for="person-user-form-state">State</label>
          <input type="text" id="person-user-form-state" placeholder="Provide a state for this person" v-model="person.state"/>
        </div>

        <div class="u-mb2 u-form-shortWrapper">
          <label for="person-user-form-zip">
            ZIP
            <span data-error v-show="errors.has('zip')">{{ errors.first('zip') }}</span>
          </label>
          <input type="text" name="zip" id="person-user-form-zip" placeholder="Provide a ZIP code for this person" v-model="person.zip" v-validate="{ required: false, numeric: true }"/>
        </div>

        <div class="u-mb2 u-form-shortWrapper">
          <label for="person-user-form-street-address-1">Steet Address 1</label>
          <input type="text" id="person-user-form-street-address-1" placeholder="Provide a street address for this person" v-model="person.streetAddress1"/>
        </div>

        <div class="u-mb2 u-form-shortWrapper">
          <label for="person-user-form-street-address-2">Steet Address 2</label>
          <input type="text" id="person-user-form-street-address-2" placeholder="Provide a street address for this person" v-model="person.streetAddress2"/>
        </div>

        <div class="u-mb2 u-form-shortWrapper">
          <label for="person-user-form-street-address-3">Steet Address 3</label>
          <input type="text" id="person-user-form-street-address-3" placeholder="Provide a street address for this person" v-model="person.streetAddress3"/>
        </div>

        <div class="u-form-actions u-mt4">
          <button type="submit" class="Button Button--square">Submit</button>
          <button @click="cancel" type="button" class="Button Button--outline">Cancel</button>
        </div>
      </div>
      <div v-else class="u-richtext u-richtext--scale">
        <p class="u-mb2">Thank you for providing this information and for helping us hold prosecutors across the nation accountable to the communities they serve.</p>
        <p class="u-mb4">We will review your submission and update our directory once it is approved.</p>
        <button @click="cancel" type="button" class="Button Button--square">Close</button>
      </div>
    </form>
  </div>
  <div v-else>
    <p class="Modal-subtitle u-center">Become a member to contribute to our database.</p>
    <p class="u-mt2 u-center">
      <a class="Button" href="/signup">
        <span class="Button-inner">Sign up</span>
      </a>
    </p>
  </div>
</template>



// WEBPACK FOOTER //
// person-user-submission-form.vue?66a16157